{
  "about.blocks": "Moderatsiya qilingan serverlar",
  "about.contact": "Ulanish:",
  "about.disclaimer": "Mastodon bepul, ochiq kodli dastur va Mastodon gGmbH kompaniyasining savdo belgisidir.",
  "about.domain_blocks.no_reason_available": "Sabab mavjud emas",
  "about.domain_blocks.preamble": "Mastodon odatda fediversedagi istalgan boshqa serverdagi foydalanuvchilar tarkibini ko'rish va ular bilan muloqot qilish imkonini beradi. Bu alohida serverda qilingan istisnolar.",
  "about.domain_blocks.silenced.explanation": "Bu serverdagi profillar va kontentni koʻrmaysiz, agar siz uni aniq koʻrib chiqmasangiz yoki unga amal qilish orqali kirishni xohlamasangiz.",
  "about.domain_blocks.silenced.title": "Cheklangan",
  "about.domain_blocks.suspended.explanation": "Ushbu serverdan hech qanday ma'lumot qayta ishlanmaydi, saqlanmaydi yoki almashtirilmaydi, bu esa ushbu serverdagi foydalanuvchilar bilan hech qanday o'zaro aloqa yoki aloqani imkonsiz qiladi.",
  "about.domain_blocks.suspended.title": "To‘xtatildi",
  "about.not_available": "Ushbu ma'lumot ushbu serverda mavjud emas.",
  "about.powered_by": "{mastodon} tomonidan boshqariladigan markazlashtirilmagan ijtimoiy media",
  "about.rules": "Server qoidalari",
  "account.add_or_remove_from_list": "Roʻyxatlarga qoʻshish yoki oʻchirish",
  "account.badges.bot": "Bo't",
  "account.badges.group": "Guruhlar",
  "account.block": "Blok @{name}",
  "account.block_domain": "{domain} domenini bloklash",
  "account.blocked": "Bloklangan",
  "account.cancel_follow_request": "Kuzatuv so‘rovini bekor qilish",
  "account.disable_notifications": "@{name} post qo‘yganida menga xabar berishni to‘xtating",
  "account.edit_profile": "Profilni tahrirlash",
  "account.enable_notifications": "@{name} post qo‘yganida menga xabar olish",
  "account.endorse": "Profildagi xususiyat",
  "account.follow": "Obuna bo‘lish",
  "account.followers": "Obunachilar",
  "account.followers.empty": "Bu foydalanuvchini hali hech kim kuzatmaydi.",
  "account.following": "Kuzatish",
  "account.follows.empty": "Bu foydalanuvchi hali hech kimni kuzatmagan.",
  "account.go_to_profile": "Profilga o'tish",
  "account.hide_reblogs": "@{name} dan boostlarni yashirish",
  "account.joined_short": "Qo'shilgan",
  "account.languages": "Obuna boʻlgan tillarni oʻzgartirish",
  "account.link_verified_on": "Bu havolaning egaligi {date} kuni tekshirilgan",
  "account.locked_info": "Bu hisobning maxfiylik holati qulflangan qilib sozlangan. Egasi ularni kim kuzatishi mumkinligini qo'lda ko'rib chiqadi.",
  "account.media": "Media",
  "account.mention": "@{name} ni zikr qiling",
  "account.moved_to": "{name} oʻzining yangi hisobi endi ekanligini aytdi:",
  "account.mute": "@{name} ovozini o‘chirish",
  "account.muted": "Ovozsiz",
  "account.open_original_page": "Original post sahifasi",
  "account.posts": "Postlar",
  "account.report": "@{name} xabar berish",
  "account.requested_follow": "{name} sizni kuzatishni soʻradi",
  "account.share": "@{name} profilini ulashing",
  "account.show_reblogs": "@{name} dan bootlarni ko'rsatish",
  "account.unblock": "@{name} ni blokdan chiqarish",
  "account.unblock_domain": "{domain} domenini blokdan chiqarish",
  "account.unblock_short": "Blokdan chiqarish",
  "account.unendorse": "Profilda ko'rsatilmasin",
  "account.unfollow": "Kuzatishni To'xtatish",
  "account.unmute": "@{name} ovozini yoqish",
  "account.unmute_short": "Ovozni yoqish",
  "account_note.placeholder": "Eslatma qo'shish uchun bosing",
  "admin.dashboard.daily_retention": "Ro'yxatdan o'tgandan keyingi kun bo'yicha foydalanuvchini ushlab turish darajasi",
  "admin.dashboard.monthly_retention": "Ro'yxatdan o'tgandan keyin oy bo'yicha foydalanuvchini ushlab turish darajasi",
  "admin.dashboard.retention.average": "O‘rtacha",
  "admin.dashboard.retention.cohort": "Ro'yxatdan o'tish oyi",
  "admin.dashboard.retention.cohort_size": "Yangi foydalanuvchilar",
  "alert.rate_limited.message": "{retry_time, time, media} keyin qayta urinib koʻring.",
  "alert.rate_limited.title": "Rate cheklangan",
  "alert.unexpected.message": "Kutilmagan xatolik yuz berdi.",
  "alert.unexpected.title": "Voy!",
  "announcement.announcement": "E'lonlar",
  "attachments_list.unprocessed": "(qayta ishlanmagan)",
  "audio.hide": "Audioni yashirish",
  "boost_modal.combo": "Keyingi safar buni oʻtkazib yuborish uchun {combo} tugmasini bosishingiz mumkin",
  "bundle_column_error.copy_stacktrace": "Xato hisobotini nusxalash",
  "bundle_column_error.error.body": "Soʻralgan sahifani koʻrsatib boʻlmadi. Buning sababi bizning kodimizdagi xato yoki brauzer mosligi muammosi bo'lishi mumkin.",
  "bundle_column_error.error.title": "Voy yo'q!",
  "bundle_column_error.network.body": "Ushbu sahifani yuklashda xatolik yuz berdi. Buning sababi internet ulanishingiz yoki ushbu serverdagi vaqtinchalik muammo bo'lishi mumkin.",
  "bundle_column_error.network.title": "Tarmoq xatosi",
  "bundle_column_error.retry": "Qayta urinib ko'rish",
  "bundle_column_error.return": "Bosh sahifaga qaytish",
  "bundle_column_error.routing.body": "Soʻralgan sahifani topib boʻlmadi. Manzil satridagi URL to'g'ri ekanligiga ishonchingiz komilmi?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Yopish",
  "bundle_modal_error.retry": "Qayta urinib ko'rish",
  "closed_registrations.other_server_instructions": "Mastodon markazlashtirilmaganligi sababli, siz boshqa serverda hisob yaratishingiz va u bilan o'zaro aloqada bo'lishingiz mumkin.",
  "closed_registrations_modal.description": "{domain} da hisob yaratish hozircha imkonsiz, lekin Mastodondan foydalanish uchun maxsus {domain} hisob qaydnomasi kerak emasligini yodda tuting.",
  "closed_registrations_modal.find_another_server": "Boshqa server topish",
  "closed_registrations_modal.preamble": "Mastodon markazlashtirilmagan, shuning uchun hisob qaydnomangizni qayerda yaratmasligingizdan qat'iy nazar, siz ushbu serverdagi har kimni kuzatishingiz va ular bilan muloqot qilishingiz mumkin bo'ladi. Siz hatto uni o'zingiz ham joylashtirishingiz mumkin!",
  "closed_registrations_modal.title": "Mastodonda ro'yxatdan o'tish",
  "column.about": "Haqida",
  "column.blocks": "Bloklangan foydalanuvchilar",
  "column.bookmarks": "Xatcho‘plar",
  "column.community": "Mahalliy",
  "column.directory": "Profillarni ko'rish",
  "column.domain_blocks": "Bloklangan domenlar",
  "column.follow_requests": "So'rovlarni kuzatib boring",
  "column.home": "Bosh sahifa",
  "column.lists": "Ro‘yxat",
  "column.mutes": "Ovozsiz foydalanuvchilar",
  "column.notifications": "Bildirishnomalar",
  "column.pins": "Belgilangan post",
  "column.public": "Federatsiyalangan vaqt jadvali",
  "column_back_button.label": "Orqaga",
  "column_header.hide_settings": "Sozlamalarni yashirish",
  "column_header.moveLeft_settings": "Ustunni chapga siljiting",
  "column_header.moveRight_settings": "Ustunni o'nga siljiting",
  "column_header.pin": "Yopishtirish",
  "column_header.show_settings": "Sozlamalarni ko'rsatish",
  "column_header.unpin": "Olib qo‘yish",
  "community.column_settings.local_only": "Faqat mahalliy",
  "community.column_settings.media_only": "Faqat media",
  "community.column_settings.remote_only": "Faqat masofaviy",
  "compose.language.change": "Tilni o‘zgartirish",
  "compose.language.search": "Tillarni izlash...",
  "compose_form.direct_message_warning_learn_more": "Batafsil ma’lumot",
  "compose_form.encryption_warning": "Mastodondagi xabarlar uchdan uchgacha shifrlanmagan. Mastodon orqali hech qanday nozik ma'lumotni baham ko'rmang.",
  "compose_form.hashtag_warning": "Bu post hech qanday xeshteg ostida ko‘rsatilmaydi, chunki u ochiq emas. Faqat ochiq xabarlarni heshteg orqali qidirish mumkin.",
  "compose_form.lock_disclaimer": "Hisobingiz {locked}. Faqat obunachilarga moʻljallangan postlaringizni koʻrish uchun har kim sizni kuzatishi mumkin.",
  "compose_form.lock_disclaimer.lock": "yopilgan",
  "compose_form.placeholder": "Xalolizda nima?",
  "compose_form.poll.duration": "So‘rov muddati",
  "compose_form.poll.switch_to_multiple": "Bir nechta tanlovga ruxsat berish uchun so'rovnomani o'zgartirish",
  "compose_form.poll.switch_to_single": "Yagona tanlovga ruxsat berish uchun so‘rovnomani o‘zgartirish",
  "compose_form.spoiler.marked": "Kontent ogohlantirishini olib tashlang",
  "compose_form.spoiler.unmarked": "Kontent haqida ogohlantirish qo'shing",
  "confirmation_modal.cancel": "Bekor qilish",
  "confirmations.block.confirm": "Bloklash",
  "confirmations.delete.confirm": "Oʻchirish",
  "confirmations.delete.message": "Haqiqatan ham bu postni oʻchirib tashlamoqchimisiz?",
  "confirmations.delete_list.confirm": "Oʻchirish",
  "confirmations.delete_list.message": "Haqiqatan ham bu roʻyxatni butunlay oʻchirib tashlamoqchimisiz?",
  "confirmations.discard_edit_media.confirm": "Bekor qilish",
  "confirmations.discard_edit_media.message": "Sizda media tavsifi yoki oldindan ko‘rishda saqlanmagan o‘zgarishlar bor, ular baribir bekor qilinsinmi?",
  "confirmations.logout.confirm": "Chiqish",
  "confirmations.logout.message": "Chiqishingizga aminmisiz?",
  "confirmations.mute.confirm": "Ovozsiz",
  "confirmations.redraft.confirm": "O'chirish va qayta loyihalash",
  "confirmations.unfollow.confirm": "Kuzatishni To'xtatish",
  "conversation.delete": "Suhbatni o'chirish",
  "conversation.mark_as_read": "O'qilgan deb belgilang",
  "conversation.open": "Suhbatni ko'rish",
  "conversation.with": "{names} bilan",
  "copypaste.copied": "Ko‘chirildi",
  "directory.federated": "Faqat bilingan fediversdan",
  "directory.local": "Faqat {domain}dan",
  "directory.new_arrivals": "Yangi kelganlar",
  "directory.recently_active": "Yaqinda faol",
  "disabled_account_banner.account_settings": "Profil sozlamalari",
  "disabled_account_banner.text": "{disabledAccount} hisobingiz hozirda oʻchirib qoʻyilgan.",
  "dismissable_banner.community_timeline": "Bular akkauntlari {domain} tomonidan joylashtirilgan odamlarning eng soʻnggi ochiq postlari.",
  "dismissable_banner.dismiss": "Bekor qilish",
  "embed.instructions": "Quyidagi kodni nusxalash orqali ushbu postni veb-saytingizga joylashtiring.",
  "embed.preview": "Bu qanday ko'rinishda bo'ladi:",
  "emoji_button.activity": "Faoliyat",
  "emoji_button.clear": "Tozalash",
  "emoji_button.custom": "Boshqa",
  "emoji_button.flags": "Belgilar",
  "emoji_button.food": "Ovqat va Ichimlik",
  "emoji_button.label": "Emoji kiritish",
  "emoji_button.nature": "Tabiat",
  "emoji_button.not_found": "Mos emoji topilmadi",
  "emoji_button.objects": "Ob'ektlar",
  "emoji_button.people": "Odamlar",
  "emoji_button.recent": "Ko'p ishlatilgan",
  "emoji_button.search": "Izlash...",
  "emoji_button.search_results": "Qidiruv natijalari",
  "emoji_button.symbols": "Belgilar",
  "emoji_button.travel": "Sayohat va Joylar",
  "empty_column.account_suspended": "Hisob to‘xtatildi",
  "empty_column.account_timeline": "Bu yerda post yo'q!",
  "empty_column.account_unavailable": "Profil mavjud emas",
  "empty_column.blocks": "Siz hali hech qanday foydalanuvchini bloklamagansiz.",
  "empty_column.bookmarked_statuses": "Sizda hali xatcho‘p qo‘yilgan postlar yo‘q. Biriga xatcho‘p qo‘ysangiz, u shu yerda ko‘rinadi.",
  "empty_column.community": "Mahalliy vaqt jadvali boʻsh. To'pni aylantirish uchun hammaga ochiq narsa yozing!",
  "empty_column.domain_blocks": "Hali bloklangan domenlar mavjud emas.",
  "empty_column.explore_statuses": "Hozir hech narsa trendda emas. Keyinroq tekshiring!",
  "empty_column.follow_requests": "Sizda hali kuzatuv soʻrovlari yoʻq. Bittasini olganingizda, u shu yerda paydo bo'ladi.",
  "empty_column.followed_tags": "Siz hali hech qanday hashtagga amal qilmagansiz. Qachonki, ular shu yerda paydo bo'ladi.",
  "empty_column.hashtag": "Ushbu hashtagda hali hech narsa yo'q.",
  "empty_column.home": "Bosh sahifa yilnomangiz boʻsh! Uni to'ldirish uchun ko'proq odamlarni kuzatib boring. {suggestions}",
  "empty_column.list": "Bu ro'yxatda hali hech narsa yo'q. Ushbu roʻyxat aʼzolari yangi xabarlarni nashr qilganda, ular shu yerda paydo boʻladi.",
  "empty_column.mutes": "Siz hali hech bir foydalanuvchining ovozini o‘chirmagansiz.",
  "empty_column.notifications": "Sizda hali hech qanday bildirishnoma yo‘q. Boshqa odamlar siz bilan muloqot qilganda, buni shu yerda ko'rasiz.",
  "empty_column.public": "Bu erda hech narsa yo'q! Biror narsani ochiq yozing yoki uni toʻldirish uchun boshqa serverlardagi foydalanuvchilarni qoʻlda kuzatib boring",
  "error.unexpected_crash.explanation": "Kodimizdagi xatolik yoki brauzer mosligi muammosi tufayli bu sahifani toʻgʻri koʻrsatib boʻlmadi.",
  "error.unexpected_crash.explanation_addons": "Bu sahifani toʻgʻri koʻrsatib boʻlmadi. Bu xato brauzer qoʻshimchasi yoki avtomatik tarjima vositalaridan kelib chiqqan boʻlishi mumkin.",
  "error.unexpected_crash.next_steps": "Sahifani yangilab ko‘ring. Agar bu yordam bermasa, siz boshqa brauzer yoki mahalliy ilova orqali Mastodondan foydalanishingiz mumkin.",
  "error.unexpected_crash.next_steps_addons": "Ularni o'chirib ko'ring va sahifani yangilang. Agar bu yordam bermasa, siz boshqa brauzer yoki mahalliy ilova orqali Mastodondan foydalanishingiz mumkin.",
  "errors.unexpected_crash.copy_stacktrace": "Stacktrace-ni vaqtinchalik xotiraga nusxalash",
  "errors.unexpected_crash.report_issue": "Muammo haqida xabar berish",
  "explore.trending_links": "Yangiliklar",
  "explore.trending_statuses": "Postlar",
  "explore.trending_tags": "Hashteglar",
  "filter_modal.added.context_mismatch_explanation": "Ushbu filtr toifasi siz ushbu postga kirgan kontekstga taalluqli emas. Agar siz post ham shu kontekstda filtrlanishini istasangiz, filtrni tahrirlashingiz kerak bo'ladi.",
  "filter_modal.added.context_mismatch_title": "Kontekst mos kelmadi!",
  "filter_modal.added.expired_explanation": "Ushbu filtr toifasi muddati tugagan, uni qo‘llash uchun amal qilish muddatini o‘zgartirishingiz kerak bo‘ladi.",
  "filter_modal.added.expired_title": "Muddati tugagan filtr!",
  "filter_modal.added.review_and_configure": "Ushbu filtr toifasini koʻrib chiqish va sozlash uchun {settings_link} sahifasiga oʻting.",
  "filter_modal.added.review_and_configure_title": "Filtr sozlamalari",
  "filter_modal.added.settings_link": "sozlamalar sahifasi",
  "filter_modal.added.short_explanation": "Bu post quyidagi filtr turkumiga qo‘shildi: {title}.",
  "filter_modal.added.title": "Filter qo'shildi!",
  "filter_modal.select_filter.context_mismatch": "ushbu kontekstga taalluqli emas",
  "filter_modal.select_filter.expired": "muddati tugagan",
  "filter_modal.select_filter.prompt_new": "Yangi turkum: {name}",
  "filter_modal.select_filter.search": "Qidiring yoki yarating",
  "filter_modal.select_filter.subtitle": "Mavjud toifadan foydalaning yoki yangisini yarating",
  "filter_modal.select_filter.title": "Ushbu postni filtrlang",
  "filter_modal.title.status": "Postni filtrlash",
  "follow_request.authorize": "Ruxsat berish",
  "follow_request.reject": "Rad etish",
  "follow_requests.unlocked_explanation": "Hisobingiz bloklanmagan boʻlsa ham, {domain} xodimlari ushbu hisoblardan kuzatuv soʻrovlarini qoʻlda koʻrib chiqishingiz mumkin deb oʻylashdi.",
  "followed_tags": "Kuzatilgan hashtaglar",
  "footer.about": "Haqida",
  "footer.directory": "Profillar katalogi",
  "footer.get_app": "Ilovani yuklab oling",
  "footer.keyboard_shortcuts": "Klaviatura yorliqlari",
  "footer.privacy_policy": "Maxfiylik siyosati",
  "footer.source_code": "Kodini ko'rish",
  "generic.saved": "Saqlandi",
  "getting_started.heading": "Ishni boshlash",
  "hashtag.column_header.tag_mode.all": "va {additional}",
  "hashtag.column_header.tag_mode.any": "yoki {additional}",
  "hashtag.column_header.tag_mode.none": "{additional}siz",
  "hashtag.column_settings.select.no_options_message": "Hech qanday taklif topilmadi",
  "hashtag.column_settings.select.placeholder": "Hashtaglarni kiriting…",
  "hashtag.column_settings.tag_mode.all": "Bularning hammasi",
  "hashtag.column_settings.tag_mode.any": "Bularning har biri",
  "hashtag.column_settings.tag_mode.none": "Bularning hech biri",
  "hashtag.column_settings.tag_toggle": "Ushbu ustun uchun qo'shimcha teglarni qo'shing",
  "hashtag.follow": "Hashtagni kuzatish",
  "hashtag.unfollow": "Hashtagni kuzatishni to'xtatish",
  "home.column_settings.show_reblogs": "Boostlarni ko'rish",
  "home.column_settings.show_replies": "Javoblarni ko'rish",
  "home.hide_announcements": "E'lonlarni yashirish",
  "home.show_announcements": "E'lonlarni ko'rsatish",
  "interaction_modal.on_another_server": "Boshqa serverda",
  "interaction_modal.on_this_server": "Shu serverda",
  "keyboard_shortcuts.back": "Orqaga qaytish",
  "keyboard_shortcuts.blocked": "to open blocked users list",
  "keyboard_shortcuts.boost": "Postni boost qilish",
  "keyboard_shortcuts.column": "Fokus ustuni",
  "keyboard_shortcuts.compose": "to focus the compose textarea",
  "keyboard_shortcuts.description": "Tavsif",
  "keyboard_shortcuts.down": "to move down in the list",
  "keyboard_shortcuts.enter": "Yozuvni ochish",
  "keyboard_shortcuts.federated": "to open federated timeline",
  "keyboard_shortcuts.heading": "Keyboard Shortcuts",
  "keyboard_shortcuts.home": "to open home timeline",
  "keyboard_shortcuts.hotkey": "Qaynoq klavishlar",
  "keyboard_shortcuts.legend": "Ushbu afsonani ko'rsatish",
  "keyboard_shortcuts.local": "to open local timeline",
  "keyboard_shortcuts.mention": "to mention author",
  "keyboard_shortcuts.muted": "to open muted users list",
  "keyboard_shortcuts.my_profile": "Profilingizni ochish",
  "keyboard_shortcuts.notifications": "to open notifications column",
  "keyboard_shortcuts.open_media": "Mediani ochish",
  "keyboard_shortcuts.pinned": "Qattiqlangan postlar roʻyxatini oching",
  "keyboard_shortcuts.profile": "Muallif profilini ochish",
  "keyboard_shortcuts.reply": "Postga javob berish",
  "keyboard_shortcuts.requests": "Kuzatuv soʻrovlari roʻyxatini ochish",
  "keyboard_shortcuts.search": "Qidiruv paneliga fokus",
  "keyboard_shortcuts.spoilers": "CW maydonini ko'rsatish/yashirish",
  "keyboard_shortcuts.start": "\"Boshlash\" ustunini oching",
  "keyboard_shortcuts.toggle_hidden": "CW orqasida matnni ko'rsatish/yashirish",
  "keyboard_shortcuts.toggle_sensitivity": "Mediani ko'rsatish/yashirish",
  "keyboard_shortcuts.toot": "Yangi post boshlang",
  "keyboard_shortcuts.unfocus": "to un-focus compose textarea/search",
  "keyboard_shortcuts.up": "Roʻyxatda yuqoriga koʻtarish",
  "lightbox.close": "Yopish",
  "limited_account_hint.action": "Baribir profilni ko'rsatish",
  "lists.delete": "Roʻyxatni o'chirish",
  "lists.edit": "Roʻyxatni tahrirlash",
  "lists.replies_policy.list": "Ro'yxat a'zolari",
  "lists.replies_policy.none": "Hech kim",
  "load_pending": "{count, plural, one {# yangi element} other {# yangi elementlar}}",
  "moved_to_account_banner.text": "{movedToAccount} hisobiga koʻchganingiz uchun {disabledAccount} hisobingiz hozirda oʻchirib qoʻyilgan.",
  "navigation_bar.about": "Haqida",
  "navigation_bar.blocks": "Bloklangan foydalanuvchilar",
  "navigation_bar.bookmarks": "Xatcho‘plar",
  "navigation_bar.domain_blocks": "Bloklangan domenlar",
  "navigation_bar.filters": "E'tiborga olinmagan so'zlar",
  "navigation_bar.followed_tags": "Kuzatilgan hashtaglar",
  "navigation_bar.follows_and_followers": "Kuzatuvchilar va izdoshlar",
  "navigation_bar.lists": "Ro‘yxat",
  "navigation_bar.logout": "Chiqish",
  "navigation_bar.mutes": "Ovozsiz foydalanuvchilar",
  "navigation_bar.preferences": "Sozlamalar",
  "navigation_bar.search": "Izlash",
  "not_signed_in_indicator.not_signed_in": "Ushbu manbaga kirish uchun tizimga kirishingiz kerak.",
  "notification.own_poll": "So‘rovingiz tugadi",
  "notification.reblog": "{name} boosted your status",
  "privacy.change": "Adjust status privacy",
  "report.placeholder": "Type or paste additional comments",
  "report.submit": "Submit report",
  "report.target": "Report {target}",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "sign_in_banner.sign_in": "Sign in",
  "status.admin_status": "Open this status in the moderation interface",
  "status.copy": "Copy link to status",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.open": "Expand this status",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "upload_progress.label": "Uploading…"
}
